import Wrapper, { Label, Input, Textarea, Toggle } from './form_control.styled';
import Customselect from '../custom_select';
// import { Icon } from "@iconify/react";

type FormControlProps = {
  htmlFor?: string;
  specialLabelClassName?: string;
  labelValue?: string;
  specialClassName?: string;
  spanIcon?: any;
  inputIcon?: any;
  input?: boolean;
  value?: string;
  className?: string;
  type?: string;
  placeholder?: string;
  select?: boolean;
  options?: any;
  dropdownIcon?: any;
  onChange?: any;
  onBlur?: any;
  onKeyUp?: any;
  onClick?: any;
  passwordType?: boolean;
  textarea?: boolean;
  name?: string;
  toggle?: boolean;
  checked?: boolean;
  maxLength?: number;
  style?: any;
  inputStyle?: any;
  disabled?: boolean;
};

export default function FormControl({
  htmlFor,
  specialLabelClassName,
  labelValue,
  specialClassName,
  spanIcon,
  inputIcon,
  input,
  value,
  className,
  type,
  placeholder,
  select,
  options,
  dropdownIcon,
  onChange,
  onBlur,
  onKeyUp,
  onClick,
  passwordType,
  textarea,
  name,
  toggle,
  checked,
  maxLength,
  style,
  inputStyle,
  disabled,
}: FormControlProps) {
  return (
    <Wrapper style={style}>
      {labelValue && !toggle && (
        <Label htmlFor={htmlFor} className={specialLabelClassName}>
          {labelValue} <span className={specialClassName}>{spanIcon}</span>
        </Label>
      )}
      {input && (
        <Input>
          <input
            name={name}
            disabled={disabled}
            type={type}
            id={htmlFor}
            value={value}
            onChange={onChange}
            onClick={onClick}
            placeholder={placeholder}
            onKeyUp={onKeyUp}
            className={className}
            onBlur={onBlur}
            maxLength={maxLength}
            style={inputStyle}
          />
          {passwordType && (
            <button onClick={onClick}>
              {type === 'password' ? (
                <div // <Icon
                // icon="akar-icons:eye"
                />
              ) : (
                <div // <Icon
                // icon="charm:eye-slash"
                />
              )}
            </button>
          )}
          {inputIcon && (
            <div // <Icon
            // icon={inputIcon}
            />
          )}
        </Input>
      )}
      {select && <Customselect options={options} dropdownIcon={dropdownIcon} />}
      {textarea && (
        <Textarea placeholder={placeholder} onChange={onChange}>
          {value}
        </Textarea>
      )}
      {toggle && (
        <>
          <Toggle>
            <div className="form-check">
              {labelValue && <span>{labelValue}</span>}
              <label className="switch">
                <input type="checkbox" checked={checked} onChange={onChange} />
                <span className="slider round" />
              </label>
            </div>
          </Toggle>
        </>
      )}
    </Wrapper>
  );
}
